import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      localStorage.removeItem("hrm_token");
      return null;
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("hrm_token");
    if (!token) { setLoading(false); return; }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, email: identifier, password });
    localStorage.setItem("hrm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, password) => {
    const { data } = await api.post("/auth/register", { name, password });
    localStorage.setItem("hrm_token", data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("hrm_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
